(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[110],{

/***/ "rMfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AllInclusive", function() { return AllInclusive; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var AllInclusive = function AllInclusive(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M157.3 294.8c.8-1.2 81.1-121.5 184.3-206.6l4.8-4-37-44.2-4.7 3.9c-66.6 54.8-114.7 109-145 147.1l-25.9-51.7-51.9 25.5 69.5 139 5.9-9z"
  }), __jsx("path", {
    d: "M415.9 233.8c-32.6-1.1-214.5 80.7-229.5 90.6-11.6 7.8-3.4 29.9 11.4 35.7 47.7 18.4 89.9-46.8 146.2-10.2-31.8 3-174.2 106.6-191-11.6-95.2-39.9-133.5-65.7-148.4-36.9-14.4 27.6 3.2 27.4 152.7 127.8 19.8 13.3 42.8 28.2 59.6 30.2 66.8 8 183.2-78.6 251.1-73.2 11 .9 21.5 2.7 31.5 5.1V255.1c-30.4-11.1-61.4-20.5-83.6-21.3z"
  }));
};

/***/ })

}]);